module.exports = __webpack_public_path__ + "static/media/slideshow (12).c50f08f5.png";